export default __webpack_public_path__ + "static/2jewellerybenchesnexttoeachother-ab3bd99d98bf7f27fb880d1fba927ab0.png";